import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { StopPropagationModule } from '@y42/core/stop-propagation';
import { CheckboxCellRendererComponent } from './checkbox-cell-renderer.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatCheckboxModule, StopPropagationModule],
  declarations: [CheckboxCellRendererComponent],
  exports: [CheckboxCellRendererComponent],
})
export class CheckboxCellRendererModule {}
